import { apiClient } from './api';

export function getLatestWeather(location = 'living_room') {
  return apiClient.get(`/weather/latest?location=${encodeURIComponent(location)}`);
}

export function getWeatherHistory(location = 'living_room', from, to) {
  const params = new URLSearchParams({ location });
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  return apiClient.get(`/weather/history?${params.toString()}`);
}
